

































































































import {Component, Prop, Vue} from "vue-property-decorator";
import WipTicket from "@/domainObjects/wip/WipTicket";
import VerificationPicker from "@/view/shared-components/VerificationPicker.vue";
import {mapGetters} from "vuex";
import CustomDatePicker from "@/view/shared-components/CustomDatePicker.vue";

@Component({
    components: {CustomDatePicker, VerificationPicker},
    computed: {
        ...mapGetters(['getGroups']),
    }
})

export default class HoldActionTracker extends Vue {
    @Prop({required: true}) wipTicket!: WipTicket;

    quantityChanged(){
        this.$emit('recalculateTotalQty')
    }
}
